import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {environment} from '../../../../../../../environments/environment';
import {faPlus, faTimes} from '@fortawesome/free-solid-svg-icons';
import {Subscription} from 'rxjs';
import {StatesService} from '../../../../../../shared/services/state/states.service';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import {AuthenticationService} from '../../../../../../shared/services/authentication/authentication.service';
import {ProjectAlarmsLocationAddListComponent} from '../project-alarms-location-add-list/project-alarms-location-add-list.component';
import {ModalService} from '../../../../../../shared/services/modal/modal.service';
import {AlarmsTypes} from '../../../../../../shared/types/alarms.types';
import AlarmLocation = AlarmsTypes.AlarmLocation;


@Component({
  selector: 'app-project-alarms-location-remove-list',
  templateUrl: './project-alarms-location-remove-list.component.html',
  styleUrls: ['./project-alarms-location-remove-list.component.css']
})
export class ProjectAlarmsLocationRemoveListComponent implements OnInit, OnDestroy {
  public displayedColumns: string[] = ['id', 'name', 'action'];
  public alarmLocations: MatTableDataSource<AlarmLocation>;
  public pageSizeOptions = environment.pageSizeOptions;
  public pageSize = environment.pageSize;
  public showSpinner: boolean = false;
  public faPlus = faPlus;
  public faTimes = faTimes;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Input('alarmLocationsList') alarmLocationsList: AlarmLocation[] = [];
  public locations: number[] = [];
  @Input('projectId') projectId: number = 0;
  @Input('typeAlarm') typeAlarm: string = 'liris-location-alarm';
  @Input('readOnly') readOnly: boolean = false;
  @Input() locationDeviceType: number;
  private reloadProjectAlarmsLocationRemove: Subscription;

  constructor(private statesService: StatesService,
              private toastr: ToastrService,
              private translate: TranslateService,
              private modalService: ModalService,
              public authenticationService: AuthenticationService) {
  }

  ngOnInit() {
    if (this.readOnly) {
      this.displayedColumns = ['id', 'name'];
    }
    if (!this.readOnly) {
      this.reloadProjectAlarmsLocationRemove = this.statesService.reloadProjectAlarmsLocationRemove.subscribe(() => {
        this.initList();
      });
    }
    this.initList();

  }

  ngOnDestroy() {
    if (!this.readOnly) {
      this.reloadProjectAlarmsLocationRemove.unsubscribe();
    }
  }

  openModal(): void {
    const modalRef = this.modalService.openNgbModal(ProjectAlarmsLocationAddListComponent, {size: 'lg'});
    modalRef.componentInstance.alarmLocationsList = this.alarmLocationsList;
    modalRef.componentInstance.projectId = this.projectId;
    modalRef.componentInstance.typeAlarm = this.typeAlarm;
    modalRef.componentInstance.locationDeviceType = this.locationDeviceType;
  }


  applyFilter(filterValue: string): void {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.alarmLocations.filter = filterValue;
  }

  removeLocationToProject(location: any): void {
    const alarmLocationsListTemp: any[] = [];
    this.alarmLocationsList.forEach(alarmLocation => {
      if (location.id !== alarmLocation.id) {
        alarmLocationsListTemp.push(alarmLocation);
      }
    });
    this.alarmLocationsList = alarmLocationsListTemp;
    this.initList();
  }

  setLocations(): void {
    this.locations = [];
    this.alarmLocations.data.forEach((location) => {
      this.locations.push(location.id);
    });
  }

  removeAllLocations(): void {
    const res = confirm(this.translate.instant('ALL_LOCATIONS_DELETION_CONFIRMATION'));
    if (res) {
      this.alarmLocationsList = [];
      this.initList();
    }
  }

  private initList(): void {
    this.alarmLocations = new MatTableDataSource(this.alarmLocationsList);
    this.alarmLocations.filter = null;
    this.alarmLocations.sort = this.sort;
    this.alarmLocations.paginator = this.paginator;
    this.setLocations();

  }

}
